import type { Carer } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

const useHasHomesList = (): boolean => {
  const hasHomesList: boolean | undefined = useSelector(
    (state: { global: { user: Carer } }) => !!state?.global?.user?.homes?.length
  )

  return hasHomesList
}

export default useHasHomesList
